import type { Questionnaire } from '../../../types/ninox.types';
import type { FieldsProps } from '../../organisms/Form/Form';

export const questionnaireFields: FieldsProps<Questionnaire> = [
  {
    name: 'mainDisease',
    // "What illness are you currently suffering from? If your illness is not listed, what is your main complaint?"
    title:
      'An welcher Krankheit leiden Sie derzeit? Falls Ihre Krankheit nicht aufgeführt ist, was ist Ihre Hauptbeschwerde?',
    type: 'radios',
    options: [
      'Chronische Schmerzen', // Chronic pain
      'Migräne/Kopfschmerzen', // Migraine/headaches
      'Schlafstörungen', // Sleep disorders
      'ADHS', // ADHD
      'Depression', // Depression
      'Angststörungen / Posttraumatische Belastungsstörung', // Anxiety disorders / post-traumatic stress disorder
      'Erkrankung des Nervensystems (Spastik, Tourette)', // Nervous system disease (spasticity, Tourette's)
      'MS', // MS (Multiple sclerosis)
      'Chronisch entzündliche Darmerkrankung / MC / Colitis', // Chronic inflammatory bowel disease / Crohn’s disease / colitis
      'Appetitlosigkeit / Übelkeit', // Loss of appetite / nausea
      'Andere nicht aufgeführte Erkrankungen', // Other diseases not listed
    ],
    otherOption: 'Andere nicht aufgeführte Erkrankungen',
  },
  {
    name: 'sinceDisease',
    // "Since when have you been suffering from this main illness?"
    title: 'Seit wann leiden Sie an dieser Haupterkrankung?',
    type: 'radios',
    options: ['weniger als 3 Monate', '3-6 Monate', 'Mehr als 6 Monate'],
  },
  {
    name: 'otherDisease',
    // "In addition to one of the previously selected illnesses, do you suffer from other illnesses?"
    title: 'Leiden Sie zusätzlich zu einer der vorab ausgewählten Erkrankungen an weiteren Erkrankungen?',
    type: 'radios',
    options: ['Ja', 'Nein'],
    otherOption: 'Ja',
  },
  {
    name: 'diagnosticDoctor',
    // "Which doctors or therapists have you already consulted because of the illness?"
    title: 'Bei welchen Ärzten oder Therapeuten haben Sie sich aufgrund der Erkrankung bereits vorgestellt?',
    type: 'radios',
    options: [
      'Hausarzt', // General practitioner
      'Facharzt (z.B. Orthopäde, Neurologe, Psychiater, Gastroenterologe/Internist)', // Specialist doctor (e.g., orthopaedist, neurologist, psychiatrist, gastroenterologist/internist)
      'Psychotherapeut', // Psychotherapist
      'Sonstiges', // Other
      'Bisher bei keinem Arzt/Therapeuten', // So far with no doctor/therapist
    ],
    otherOption: 'Sonstiges',
  },
  {
    name: 'otherMedicines',
    // "Have you already tried medication because of your illness?"
    title: 'Haben Sie bereits Medikamente aufgrund Ihrer Erkrankung ausprobiert?',
    type: 'radios',
    options: ['Ja', 'Nein'],
    otherOption: 'Ja',
  },
  {
    name: 'therapiesMedicationCondition',
    // "Which additional complementary therapy options have you already tried?"
    title: 'Welche weiteren ergänzenden Therapieoptionen haben Sie bereits ausprobiert?',
    type: 'radios',
    options: [
      'Psychotherapie', // Psychotherapy
      'Physiotherapie', // Physiotherapy
      'Akupunktur', // Acupuncture
      'Osteopathie', // Osteopathy
      'Hypnose', // Hypnosis
      'Entspannungstechniken', // Relaxation techniques
      'Chiropraktiker', // Chiropractor
      'Homöopathie', // Homeopathy
      'Andere Therapieoptionen', // Other therapy options
      'Keine Therapieoptionen', // No therapy options
    ],
    otherOption: 'Andere Therapieoptionen',
  },
  {
    name: 'isAlreadyCannabisPatient',
    // "Have you already been treated with medical cannabis?"
    title: 'Wurden Sie bereits mit medizinischem Cannabis behandelt?',
    type: 'checkbox',
  },
  {
    name: 'isPregnant',
    // "Are you pregnant?"
    title: 'Sind sie schwanger?',
    type: 'checkbox',
  },
  {
    name: 'takeOtherMedicines',
    // "Are you currently taking drugs?"
    title: 'Nehmen Sie aktuell Drogen ein?',
    type: 'checkbox',
  },
  {
    name: 'symptomComment',
    // "Please confirm that you do not suffer from any of these illnesses or symptoms, or select the corresponding illness that applies to you."
    title:
      'Bitte bestätigen Sie, dass Sie an keiner dieser Erkrankungen oder Symptomen leiden, oder wählen Sie die entsprechende Erkrankung aus, die auf Sie zutrifft.',
    options: [
      'Hiermit bestätige ich, an keiner der genannten Erkrankungen oder Symptome zu leiden.', // I hereby confirm that I do not suffer from any of the mentioned diseases or symptoms.
      'Psychose (Schizophrenie, Wahnvorstellungen, Halluzinationen)', // Psychosis (schizophrenia, delusions, hallucinations)
      'Persönlichkeitsstörung (z. B. Borderline)', // Personality disorder (e.g., borderline)
      'Bipolare Störung', // Bipolar disorder
      'Suchterkrankung', // Addiction disorder
      'Koronare Herzkrankheit, Herzinsuffizienz, Herzrhythmusstörung', // Coronary heart disease, heart failure, cardiac arrhythmia
      'Herzinfarkt, Schlaganfall, Thrombose/Embolie', // Heart attack, stroke, thrombosis/embolism
      'Schwere Leber- oder Nierenerkrankung', // Severe liver or kidney disease
      'Allergie gegen THC/CBD-haltige Produkte', // Allergy to THC/CBD-containing products
    ],
    type: 'radios',
  },
];
